module.exports = __webpack_public_path__ + "img/money-1.dd834ded.png";